import React, { useState, useEffect, createRef } from "react";
import {
  TextArea,
  Modal,
  Dropdown,
  Input,
  Form,
  Button,
  Divider,
  Icon,
  Dimmer,
  Loader,
  Checkbox,
  Image,
} from "semantic-ui-react";
import * as auth from "../../modules/Auth/_redux/authRedux";
import { PhoneInput } from "react-international-phone";
import Asterisk from "../../components/common/Asterisk";
import { PhoneNumberUtil } from "google-libphonenumber";
import location_icon from "../../../Assets/Icons/location_on.jpg";
import sub_location_icon from "../../../Assets/Icons/pin_drop.png";

import { Country, State } from "country-state-city";
import { useHistory } from "react-router-dom";
import { useSelector, connect, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { selectTranslations } from "../../config/i18n/slice";
import { scrollToError } from "../../../utilFunctions/scrollToError";
import { useDropzone } from "react-dropzone";
import {
  AddIcon,
  AddIconWithCircle,
  BillingInfoIcon,
  CloseIcon,
  ContactInfoIcon,
  DeleteIcon,
  EditWhiteIcon,
  ImgPhotos,
  InfoIcon,
  InfoIconBlue,
  TextSnippet,
} from "../../../Assets/Icons/svg";
import ToolTip from "react-power-tooltip";
import { Resizable } from "re-resizable";
import useNewCancelModal from "../../../hooks/Messages/useNewCncelModal";
import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
import AddLocation from "../Locations/add";
import ImageCrop from "../MyCompanyProfile/ImageCrop";
import {
  handleKeyDown,
  validateEmail,
} from "../../config/common/commonFunctions";
import { getAllParentLocations } from "../../config/sharedApi/locationApis";
import { uploadFile, urlToFile } from "../../config/api/configApis";
import { updateCustomer } from "../../config/api/customerApis";
import { getUserData } from "../../config/sharedApi/peopleApis";
import { currencies } from "../../config/common/commonVariables";
import {
  buildValidation,
  makeOnBlurFactory,
  makeOnValuesChangeFactory,
  makeValidateOnSubmitFactory,
} from "./customersValidationRules";

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};

/*
 * The FileUpload component in JavaScript allows users to upload files with customizable drag and drop functionality.
 */
const FileUpload = ({
  onFileChange,
  name = "",
  attachments = {},
  setPersonalImgId,
  setAttachments = () => {},
  setImageSrc = () => {},
  setFile = () => {},
}) => {
  const fileTypes = {
    images: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/svg+xml",
      "image/webp",
      "image/heic",
    ],
    documents: [
      "text/plain",
      "application/pdf",
      "text/csv",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    video: ["video/mp4", "video/quicktime", "video/webm", "video/hevc"],
  };

  const { getRootProps, getInputProps } = useDropzone({
    // accept: Object.fromEntries(fileTypes.images.map((type) => [type, []])),
    onDrop: (acceptedFiles) => {
      const allowedFileTypes = [...fileTypes.images];

      // Validate file types
      const invalidFiles = acceptedFiles.filter(
        (file) => !allowedFileTypes.includes(file.type)
      );

      // Show toast if there are invalid files
      if (invalidFiles?.length > 0) {
        toast.error(t.common.invalid_msg);
        return;
      }
      let totalSize = organisationImage?.attachmentsSize
        ? organisationImage?.attachmentsSize
        : 200;
      const validFiles = acceptedFiles.filter((file) => {
        const isImage = fileTypes.images.includes(file.type);
        const isDocument = fileTypes.documents.includes(file.type);

        const isVideo = fileTypes.video.includes(file.type);

        const validSize =
          (isVideo || isImage || isDocument) &&
          file.size < totalSize * 1024 * 1024;

        if (!validSize) {
          toast.error(
            `${t.common.file_upload_valid} ${totalSize} ${t.common.file_upload_second}`
          );
          return false;
        }
        return true;
      });

      onFileChange(validFiles, name);
    },
  });
  const t = useSelector(selectTranslations);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });
  const organisationImage = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation;
    } else {
      return null;
    }
  });
  //TO DO : Customize and Style this Drag and Drop to Upload box as you want🧑‍💻😊
  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {name === "image" ? (
        attachments?.image?.name ? (
          <div className="user-img-avatar position-relative">
            <Image
              avatar
              title={attachments?.image?.name}
              src={`${attachments?.image?.url}`}
         
            />
            <span
              className={`people-circle-image ${
                selectedLanguage == "en" ? "" : "rtl-people"
              }`}
            >
              <span
                className={`edit-container ${
                  selectedLanguage == "en" ? "" : "rtl-edit"
                }`}
              >
                <EditWhiteIcon /> {t.common.edit}
              </span>
            </span>

            <span
              className="ml-3 mr-3 c-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setPersonalImgId(null);
                setFile("");
                setImageSrc("");
                setAttachments({
                  ...attachments,
                  image: null,
                });
              }}
            >
              <DeleteIcon />
            </span>
          </div>
        ) : (
          <div className="image-dropzone  text-center mb-5">
            <div>
              <p className="p1">
                <div className="d-flex align-items-start justify-content-center ">
                  <div>
                    {" "}
                    <ImgPhotos />
                  </div>
                  <div
                    className={`mr-2 ml-2 ${
                      selectedLanguage == "en" ? "text-left" : "text-right"
                    }`}
                  >
                    {" "}
                    <div className="blue-text"> {t.common.upload_img}</div>{" "}
                    <p className="mb-0 files-text">
                      {" "}
                      {t.common.valid_files_img}
                    </p>{" "}
                  </div>
                </div>
              </p>
            </div>
          </div>
        )
      ) : attachments?.warrantyFile?.name ? (
        <div className="warrenty-file-dropzone text-center">
          <label>
            {attachments?.warrantyFile?.name}
            <span
              className="ml-3 mr-3 c-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setAttachments({
                  ...attachments,
                  warrantyFile: null,
                });
              }}
            >
              <DeleteIcon />
            </span>
          </label>
        </div>
      ) : (
        <div className="warrenty-file-dropzone d-flex align-items-center justify-content-between">
          <div className="d-flex ml-4 mr-4">
            <TextSnippet />
            <div className="pl-4 pr-4">
              <p className="p1 m-0">Warranty file</p>
              <p className="p2 m-0">Attach a file to this asset</p>
            </div>
          </div>
          <div>
            <AddIconWithCircle />
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * The `Edit` function in JavaScript is a component that allows users to edit customer information, including details, contact information, and billing information, with validation and file upload functionality.
 */
function Edit(props) {
  const {
    toggled,
    untoggle,
    refresh,
    setRefresh,
    targetedData,
    setFilterOptions,
    setSearchTitle,
    role,
    allIds,
    setToggleEditModal,
    setAllIds,
  } = props;
  const history = useHistory();
  const t = useSelector(selectTranslations);
  const dispatch = useDispatch();
  const [personalImgId, setPersonalImgId] = useState();
  const [locationLoading, setlocationLoading] = useState(true);
  const [showCancleTooltip, setCancleTooltip] = useState(false);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });
  const [showTeamsTooltip, setTeamsTooltip] = useState(false);
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });
  const currentUserId = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.id;
    } else {
      return null;
    }
  });
  const [file, setFile] = useState("");
  const [imageSrc, setImageSrc] = useState("");
  const [toggleAsideModal, setToggleAsideModal] = useState(false);
  const [initChange, setInitChange] = useState(false);
  const { setNewCancelModal, NewCancelModal } = useNewCancelModal();
  const [buttonStatus, setButtonStatus] = useState(0);
  const [activePane, setActivePane] = useState(0);
  const [logo, setLogo] = useState(null);

  const [cancelModal, toggleCancelModal] = useState(false);
  const [successModal, toggleSuccessModal] = useState(false);
  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );
  const [phone, setPhone] = useState(false);
  const logoRef = createRef();

  const [responseData, setResponseData] = useState({});
  const { userPermissions } = usePermissionsSimplified();
  const [fetchingCountries, setFetchingCountries] = useState(true);
  const [fetchingCities, setFetchingCities] = useState(true);
  const [options, setOptions] = useState({
    locations: {
      initOptions: [],
      options: [],
    },
    countries: [],
    cities: [],
    Industry: [
      {
        key: "industry1",
        value: "Commercial Real Estate Companies",
        text: t.customers.industry.commercial,
      },
      {
        key: "industry2",
        value: "Corporate Offices",
        text: t.customers.industry.corporate,
      },
      {
        key: "industry3",
        value: "Manufacturing Companies",
        text: t.customers.industry.manufacturing,
      },
      {
        key: "industry4",
        value: "Healthcare Organizations",
        text: t.customers.industry.healthcare,
      },
      {
        key: "industry5",
        value: "Educational Institutions",
        text: t.customers.industry.educational,
      },
      {
        key: "industry6",
        value: "Government and Public Sector Organizations",
        text: t.customers.industry.government,
      },
      {
        key: "industry7",
        value: "Hospitality and Entertainment Companies",
        text: t.customers.industry.hospitality,
      },
      {
        key: "industry8",
        value: "Data Centers",
        text: t.customers.industry.data_centers,
      },
      {
        key: "industry9",
        value: "Retail Companies",
        text: t.customers.industry.retails,
      },
      {
        key: "industry10",
        value: "Sports and Recreation Facilities",
        text: t.customers.industry.sports,
      },
    ],
  });
  const [data, setData] = useState({
    name: "",
    isSame: false,
    address: "",
    location: [],
    selectedLocation: [],
    countryCode: "962",
    phone: "",
    website: "",
    email: "",
    serviceType: "",
    description: "",
    country: "",
    city: "",
    billing_name: "",
    billing_postal_code: "",
    billing_address: "",
    billing_addressLine2: "",
    billing_addressLine3: "",
    billing_rate: 0,
    billing_currency: "JOD",
    Industry: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
  });

  const [attachments, setAttachments] = useState({
    image: null,
  });
  const [validation, setValidation] = useState(() => buildValidation(t));

  const getCustomerData = () => data;
  const getOptions = () => options;

  const makeOnBlur = makeOnBlurFactory({
    getCustomerData,
    setValidation,
  });

  const onValuesChange = makeOnValuesChangeFactory({
        getCustomerData,
        setCustomerData: setData,
        setValidation,
        getOptions,
        setOptions,
        setInitChange,
  });

  const validateAll = makeValidateOnSubmitFactory({
        getCustomerData,
        validation,
        setValidation,
  });

  /*
   * The `resetForm` function resets all form data, validation messages, modal width, attachments, and other state variables to their initial values.
   */
  const resetForm = () => {
    setData({
      contact_name: "",
      contact_phone: "",
      contact_email: "",
      isSame: false,
      name: "",
      address: "",
      location: [],
      selectedLocation: [],
      countryCode: "962",
      phone: "",
      website: "",
      email: "",
      serviceType: "",
      description: "",
      country: "",
      city: "",
      billing_name: "",
      billing_postal_code: "",
      billing_address: "",
      billing_addressLine2: "",
      billing_addressLine3: "",
      billing_rate: 0,
      billing_currency: "JOD",
      Industry: "",
    });

    setlocationLoading(true);
    setValidation(buildValidation(t));

    setModalWidth(Math.max(window.innerWidth / 2, 514));
    setLogo(null);
    setAttachments({
      image: null,
    });
    setFile("");
    setImageSrc("");
    setPersonalImgId(null);
    setFetchingCountries(true);
    setFetchingCities(true);
    setActivePane(0);

    setInitChange(false);
  };

  const user = useSelector((state) => {
    if (state?.auth?.user) {
      return state.auth.user;
    } else {
      return null;
    }
  });

  /*
   * The function `fetchLocationsOptions` fetches all locations for a given organization and updates the options state with the retrieved data.
   */
  const fetchLocationsOptions = async (updatedAllIds = []) => {
    setOptions({
      ...options,
      locations: {
        initOptions: [],
        options: [],
      },
    });

    let finalIds = [...allIds];

    if (updatedAllIds?.length > 0) {
      finalIds = [...updatedAllIds];
    }
    const fetchData = await getAllParentLocations(
      organisationId,
      "",
      1,
      99999,
      [],
      [],
      [],
      ["name:asc"]
    );
    let the_options = [];
    let parentOptions = [];
    let subOptions = [];
    if (fetchData?.response?.length > 0) {
      fetchData.response.forEach((el) => {
        if (!(role === "super_admin")) {
          if (finalIds?.includes(el.id)) {
            parentOptions.push({
              key: el.id,
              value: el.id,
              text: el.attributes.name,
              image: { src: location_icon },
              className: "main-location-dropdown-option",
              disabled: false,
            });

            if (el?.attributes?.subLocations?.data?.length > 0) {
              el.attributes.subLocations.data.forEach((subEl) => {
                if (finalIds?.includes(subEl.id)) {
                  subOptions.push({
                    key: subEl.id,
                    value: subEl.id,
                    text: subEl.attributes.name,
                    image: { src: sub_location_icon },
                    className: "sub-location-dropdown-option",
                    parentId: el.id,
                  });
                }
              });
            }
          } else {
            const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
              (subEl) => finalIds?.includes(subEl.id)
            );

            if (hasMatchingSubLocation) {
              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                image: { src: location_icon },
                className: "main-location-dropdown-option",
                disabled: true,
              });

              // Collect matching sub-options
              el?.attributes?.subLocations?.data?.length > 0 &&
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (finalIds?.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      image: { src: sub_location_icon },
                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
            }
          }
        } else {
          parentOptions.push({
            key: el.id,
            value: el.id,
            disabled: false,
            text: el.attributes.name,
            image: { src: location_icon },
            className: "main-location-dropdown-option",
          });

          if (el?.attributes?.subLocations?.data?.length > 0) {
            el.attributes.subLocations.data.forEach((subEl) => {
              subOptions.push({
                key: subEl.id,
                value: subEl.id,
                text: subEl.attributes.name,
                image: { src: sub_location_icon },
                className: "sub-location-dropdown-option",
                parentId: el.id,
              });
            });
          }
        }
      });

      // Sort sub-options alphabetically
      subOptions.sort((a, b) => a.text.localeCompare(b.text));

      // Merge parent options with sorted sub-options
      parentOptions.forEach((parentOption) => {
        the_options.push(parentOption);
        // Add sorted sub-options belonging to this parent
        subOptions.forEach((subOption) => {
          if (subOption.parentId === parentOption.key) {
            the_options.push(subOption);
          }
        });
      });

      // Update the options state
      setOptions((prev) => ({
        ...prev,
        locations: {
          initOptions: the_options,
          options: the_options,
        },
      }));

      return the_options;
    }
  };

  const fetchFirstLocationsOptions = async (updatedAllIds = []) => {
    let finalIds = [...allIds];

    if (updatedAllIds?.length > 0) {
      finalIds = [...updatedAllIds];
    }
    const fetchData = await getAllParentLocations(
      organisationId,
      "",
      1,
      99999,
      [],
      [],
      [],
      ["name:asc"]
    );
    let the_options = [];
    let all_options = [];
    let parentOptions = [];
    let subOptions = [];
    if (fetchData?.response?.length > 0) {
      fetchData.response.forEach((el) => {
        if (!(role === "super_admin")) {
          if (finalIds?.includes(el.id)) {
            parentOptions.push({
              key: el.id,
              value: el.id,
              text: el.attributes.name,
              image: { src: location_icon },
              className: "main-location-dropdown-option",
              disabled: false,
            });

            if (el?.attributes?.subLocations?.data?.length > 0) {
              el.attributes.subLocations.data.forEach((subEl) => {
                if (finalIds?.includes(subEl.id)) {
                  subOptions.push({
                    key: subEl.id,
                    value: subEl.id,
                    text: subEl.attributes.name,
                    image: { src: sub_location_icon },
                    className: "sub-location-dropdown-option",
                    parentId: el.id,
                  });
                }
              });
            }
          } else {
            const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
              (subEl) => finalIds?.includes(subEl.id)
            );

            if (hasMatchingSubLocation) {
              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                image: { src: location_icon },
                className: "main-location-dropdown-option",
                disabled: true,
              });

              // Collect matching sub-options
              el?.attributes?.subLocations?.data?.length > 0 &&
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (finalIds?.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      image: { src: sub_location_icon },
                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
            }
          }
        } else {
          parentOptions.push({
            key: el.id,
            value: el.id,
            disabled: false,
            text: el.attributes.name,
            image: { src: location_icon },
            className: "main-location-dropdown-option",
          });

          if (el?.attributes?.subLocations?.data?.length > 0) {
            el.attributes.subLocations.data.forEach((subEl) => {
              subOptions.push({
                key: subEl.id,
                value: subEl.id,
                text: subEl.attributes.name,
                image: { src: sub_location_icon },
                className: "sub-location-dropdown-option",
                parentId: el.id,
              });
            });
          }
        }
      });

      // Sort sub-options alphabetically
      subOptions.sort((a, b) => a.text.localeCompare(b.text));

      // Merge parent options with sorted sub-options
      parentOptions.forEach((parentOption) => {
        the_options.push(parentOption);
        all_options.push(parentOption);
        // Add sorted sub-options belonging to this parent
        subOptions.forEach((subOption) => {
          if (subOption.parentId === parentOption.key) {
            the_options.push(subOption);
            all_options.push(subOption);
          }
        });
      });

      let locationsData =
        targetedData?.attributes?.locations?.data?.length > 0
          ? targetedData?.attributes.locations.data.map((el_loc) => el_loc.id)
          : [];

      let result = [];
      let removedIds = [];
      locationsData?.length > 0 &&
        locationsData.forEach((id) => {
          // Find the option corresponding to the current id
          const option = all_options.find((o) => o.key == id);

          if (option) {
            // If the option is available and has a parentId
            if (option.parentId) {
              // Check if the parentId exists in the options and the 'disabled' field is false
              const parentOption = all_options.find(
                (o) => o.key == option.parentId && o.disabled === false
              );

              if (locationsData?.includes(parentOption?.key)) {
                // If parent is available and not disabled, push the parent's id
                result.push(parentOption.id);

                // Remove the ID from all_options and track it in removedIds
                all_options = all_options.filter((o) => o.key != id);
                removedIds.push(id); // Track removed ID
              } else {
                result.push(id);
              }
            } else {
              // If the option has no parentId, push the current id
              result.push(id);
            }
          }
        });

      let finalResult = result.filter((result) => result !== undefined);

      setData((prev) => {
        return {
          ...prev,
          location: [...new Set(finalResult)],
        };
      });

      // Update the options state
      setOptions((prev) => ({
        ...prev,
        locations: {
          initOptions: the_options,
          options: all_options,
        },
      }));

      setlocationLoading(false);

      return the_options;
    }
  };

  useEffect(() => {
    if (toggled) {
      fetchOptions();
      fetchFirstLocationsOptions();
      if (targetedData) {
        setData({
          ...data,
          name: targetedData?.attributes?.name,
          contact_email:
            targetedData?.attributes?.contactInformation?.email || "",
          contact_phone:
            targetedData?.attributes?.contactInformation?.phone || "",
          contact_name:
            targetedData?.attributes?.contactInformation?.name || "",
          isSame: targetedData?.attributes?.contactInformation?.isSame,
          address: targetedData?.attributes?.address,
          country: targetedData?.attributes?.billingInformation?.country,
          city: targetedData?.attributes?.billingInformation?.city,

          phone: targetedData?.attributes?.phone || "",
          website: targetedData?.attributes?.website,
          email: targetedData?.attributes?.email || "",
          Industry: targetedData?.attributes?.Industry || "",

          selectedLocation:
            targetedData?.attributes?.locations?.data?.length > 0
              ? targetedData?.attributes.locations.data.map(
                  (el_loc) => el_loc.id
                )
              : [],
          serviceType: targetedData?.attributes?.serviceType,
          description: targetedData?.attributes?.description,
          billing_name: targetedData?.attributes?.billingInformation?.name,
          billing_postal_code:
            targetedData?.attributes?.billingInformation?.postalCode,
          billing_address:
            targetedData?.attributes?.billingInformation?.address,
          billing_addressLine2:
            targetedData?.attributes?.billingInformation?.addressLine2,
          billing_addressLine3:
            targetedData?.attributes?.billingInformation?.addressLine3,
          billing_rate: targetedData?.attributes?.billingInformation?.rate,
          billing_currency:
            targetedData?.attributes?.billingInformation?.currency,
        });

        setAttachments({
          ...attachments,
          image: targetedData?.attributes?.logo?.data
            ? {
                id: targetedData?.attributes?.logo?.data.id,
                file: urlToFile(
                  targetedData?.attributes?.logo?.data.attributes.url,
                  targetedData?.attributes?.logo?.data.attributes.name
                ),
                url: targetedData?.attributes?.logo?.data.attributes.url,
                name: targetedData?.attributes?.logo?.data.attributes.name,
                type: targetedData?.attributes?.logo?.data.attributes.mime,
                cancelPopup: false,
                isChanged: false,
              }
            : null,
        });
      }
    }
  }, [targetedData, toggled]);

  /*
   * The function fetchOptions asynchronously retrieves countries and cities data, maps them to specific options format, and updates the state with the fetched options.
   */
  const fetchOptions = async () => {
    const [countries, cities] = await Promise.all([
      Country.getAllCountries(),
      State.getStatesOfCountry(
        targetedData?.attributes?.billingInformation?.country
      ),
    ]);

    let countries_options = [];
    if (countries) {
      countries_options = countries.map((el) => {
        return {
          key: el?.isoCode?.toLowerCase(),
          value: el?.isoCode,
          text: el.name,
          flag: el?.isoCode?.toLowerCase(),
        };
      });
      setFetchingCountries(false);
    }

    let cities_options = [];
    if (cities) {
      cities_options = cities.map((el) => {
        return {
          key: el.isoCode,
          value: el.isoCode,
          text: el.name,
        };
      });
      setFetchingCities(false);
    }
    setOptions((pre) => ({
      ...pre,
      countries: countries?.length > 0 ? countries_options : [],
      cities: cities?.length > 0 ? cities_options : [],
    }));
  };

  /*
   * The function `onFileChange` handles file uploads, sets initial changes, generates a random number, uploads an image file if the name is 'image', and updates the attachments state with file details.
   */
  const onFileChange = async (files, name) => {
    setInitChange(true);
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setImageSrc(reader.result);
    });
    reader.readAsDataURL(files[0]);

    setFile({
      name: files[0]?.name,
      type: files[0]?.type,
    });
  };

  /*
   * The function `changeTab` switches to a different tab if there are no validation errors, otherwise it scrolls to the first error.
   */
  const changeTab = async (tab, errors, setFieldTouched, values) => {
    let errorsInData = validateAll();

    if (!errorsInData) {
      setActivePane(tab);
      return;
    } else {
      scrollToError();
    }
  };

  const fetchCountriesOptions = () => {
    const countries = Country.getAllCountries();
    if (countries) {
      const _g_options = countries.map((el) => {
        return {
          key: el?.isoCode?.toLowerCase(),
          value: el?.isoCode,
          text: el.name,
          flag: el?.isoCode?.toLowerCase(),
        };
      });
      setOptions({
        ...options,
        countries: _g_options,
      });

      setFetchingCountries(false);
    }
  };

  useEffect(() => {
    if (options.countries.length > 0 && !fetchingCountries) {
      setData({
        ...data,
        country: targetedData?.attributes?.billingInformation?.country,
      });

      fetchCitiesOptions(targetedData?.attributes?.billingInformation?.country);
    }
  }, [fetchingCountries]);

  /*
   * The function `fetchCitiesOptions` fetches and sets options for cities based on a given country code.
   */
  const fetchCitiesOptions = (code) => {
    const fetchData = State.getStatesOfCountry(code);

    if (fetchData.length > 0) {
      // console.log(fetchData);
      let the_options = fetchData.map((el) => {
        return {
          key: el.isoCode,
          value: el.isoCode,
          text: el.name,
        };
      });
      setOptions({
        ...options,
        cities: the_options,
      });

      setFetchingCities(false);
    }
  };

  /*
   * The fetchCities function fetches states of a country and maps them to options for cities.
   */
  const fetchCities = async () => {
    const fetchData = State.getStatesOfCountry(data.country);

    if (fetchData.length > 0) {
      let the_options = fetchData.map((el) => {
        return {
          key: el.isoCode,
          value: el.isoCode,
          text: el.name,
        };
      });
      setOptions({
        ...options,
        cities: the_options,
      });
    } else {
      setOptions({
        ...options,
        cities: [],
      });
    }
  };

  useEffect(() => {
    fetchCities();
  }, [data.country]);

  useEffect(() => {
    if (options.cities.length > 0 && !fetchingCities) {
      setData({
        ...data,
        city: targetedData?.attributes?.billingInformation?.city,
      });
    }
  }, [fetchingCities]);

  /*
   * The `onValuesChange` function handles changes in form input values, updating the data state based on the input type (text or dropdown) and performing validation checks.
   */

  /*
   * The `validationHandler` function updates validation properties based on data input and checks for any errors in the data.
   */

  /*
   * The function `updateCustomerHandler` handles the updating of customer information with validation checks and error handling.
   */
  const updateCustomerHandler = async () => {
    let errorsInData = validateAll();
    if (!errorsInData) {
      setButtonStatus(1);

      // console.log('THE DATA WE UPDATE ', data);

      const logoId = personalImgId ? personalImgId : null;

      const billingInformation = {
        name: data.billing_name ? data.billing_name : "",
        country: data.country ? data.country : "",
        city: data.city ? data.city : "",
        postalCode: data.billing_postal_code ? data.billing_postal_code : "",
        address: data.billing_address ? data.billing_address : "",
        addressLine2: data.billing_addressLine2
          ? data.billing_addressLine2
          : "",
        addressLine3: data.billing_addressLine3
          ? data.billing_addressLine3
          : "",
        rate: data?.billing_rate ? Number(data.billing_rate) : null,
        currency: data.billing_currency ? data.billing_currency : null,
      };

      const contactInformation = {
        name: data.contact_name,
        phone: data?.contact_phone ? data?.contact_phone : null,
        email: data?.contact_email ? data.contact_email : null,
        isSame: data?.isSame,
      };

      const response = await updateCustomer(
        Number(targetedData?.id),
        String(data.name),
        data.phone || null,
        data.website,
        data.email || null,
        data.serviceType,
        data.description,
        billingInformation,
        logoId,
        data?.selectedLocation,
        data.Industry || null,
        contactInformation,
        organisationId
      );

      if (response.status == 200) {
        setButtonStatus(0);
        untoggle();
        resetForm();
        setFilterOptions({
          countries: [],
          cities: [],
          locations: [],

          rate: {
            from: null,
            to: null,
          },
        });
        setSearchTitle("");

        setResponseData({
          name: response.data.name,
        });

        toast.success(t.customers.form.customer_updated_success);
      } else if (response.status == 400) {
        if (response.error && response.error.message) {
          toast.error(response.error.message);
        } else {
          toast.error(t.common.something_wrong);
          untoggle();
          resetForm();
        }
      }
      setButtonStatus(0);
    } else {
      scrollToError();
    }
  };

  /*
   * The `cancelHandler` function resets a form, adjusts the modal width, untoggles a modal, and updates state variables.
   */
  const cancelHandler = () => {
    resetForm();
    setModalWidth(Math.max(window.innerWidth / 2, 514));
    untoggle();
    setNewCancelModal(false);
    setInitChange(false);
  };
  return (
    <>
      <div
        style={{ maxWidth: `${modalWidth}px` }}
        clearing
        className={
          toggled
            ? "aside-modal preview active procedure"
            : "aside-modal preview procedure"
        }
      >
        <Resizable
          size={{ width: modalWidth, height: "auto" }}
          minWidth={"514px"}
          onResize={(e, direction, ref, d) => {
            setModalWidth(ref.offsetWidth);
          }}
        >
          <div className="modal-header">
            <div className="flexbox justify-between align-center">
              <div className="name">
                {t.customers.form.edit_customer} #
                {targetedData?.attributes?.countId}
              </div>

              <div className="flexbox align-center workorder-header-buttons">
                <span
                  className="position-relative procedure-header-button c-pointer"
                  onMouseOver={() => setCancleTooltip(true)}
                  onMouseLeave={() => setCancleTooltip(false)}
                  onClick={() =>
                    initChange ? setNewCancelModal(true) : cancelHandler()
                  }
                >
                  <CloseIcon />
                  <ToolTip
                    color="#fff"
                    backgroundColor="#172B4D"
                    position={
                      selectedLanguage == "en"
                        ? "bottom center"
                        : "bottom center"
                    }
                    show={showCancleTooltip}
                    textBoxWidth="36px"
                    arrowAlign="center"
                    padding="5px 5px 5px 7px"
                    borderRadius="5px"
                    static
                  >
                    <span className="work-order-preview-tooltip">
                      {t.common.close}
                    </span>
                  </ToolTip>
                </span>
              </div>
            </div>
          </div>
          <div className="body p-6">
            {buttonStatus == 1 ? (
              <Dimmer active inverted>
                <Loader inverted content={t.common.loading} />
              </Dimmer>
            ) : (
              ""
            )}
            <Button.Group
              className="add-people-btn customer mt-5"
              basic
              fluid
              // style={{ width: "50%" }}
              size="medium"
            >
              <Button
                active={activePane == 0}
                onClick={() => changeTab(0)}
                type="button"
              >
                {t.customers.table.details}
              </Button>

              <Button
                className="add-people-tab"
                active={activePane == 1}
                onClick={() => changeTab(1)}
                type="button"
              >
                {t.customers.form.billing_information}
              </Button>
            </Button.Group>
            <Divider
              className="mt-0 customer-divider"
              //  style={{ width: "50%" }}
            />

            <div>
              <div className={activePane === 0 ? "d-block" : "d-none"}>
                <FileUpload
                  onFileChange={onFileChange}
                  name="image"
                  attachments={attachments}
                  setImageSrc={setImageSrc}
                  setFile={setFile}
                  setAttachments={setAttachments}
                  setPersonalImgId={setPersonalImgId}
                />

                {imageSrc && (
                  <ImageCrop
                    src={imageSrc}
                    minWidth={20}
                    minHeight={20}
                    fileData={file}
                    onAccept={async (croppedImageUrl) => {
                      let CroppedFile = new File([croppedImageUrl], file.name, {
                        type: file.type,
                      });

                      var randomnumber =
                        Math.floor(Math.random() * (0 - 100 + 1)) + 100;

                      const personalPictureResponse = await uploadFile([
                        CroppedFile,
                      ]);

                      if (personalPictureResponse?.status == 200) {
                        let fileData = personalPictureResponse?.data[0]?.url;
                        setPersonalImgId(personalPictureResponse.data[0].id);
                        setImageSrc("");
                        setFile("");
                        setAttachments({
                          ...attachments,
                          ["image"]: {
                            file: CroppedFile,
                            id: randomnumber,
                            name: CroppedFile.name,
                            type: CroppedFile.type,
                            cancelPopup: false,
                            isChanged: true,
                            url: fileData ? fileData : null,
                          },
                        });
                      } else {
                        toast.error(t.common.something_wrong);
                      }
                    }}
                    onCancel={() => {
                      setImageSrc("");
                      setFile("");
                    }}
                  />
                )}

                <Form.Field>
                  <label className="label-item mt-3">
                    {t.customers.form.name}
                    <Asterisk color="#172B4D" />
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_name}
                    value={data.name}
                    onChange={onValuesChange("name")}
                    error={validation.name.error && validation.name.skipped}
                    onBlur={makeOnBlur("name")}
                  />
                  {validation.name.error && validation.name.skipped ? (
                    <div className="label-error">{validation.name.message}</div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <Form className="text-area-container">
                  <Form.Field>
                    <label className="label-item">
                      {t.customers.form.description}
                    </label>
                    <TextArea
                      autoComplete="new-password"
                      value={data.description}
                      onChange={onValuesChange("description")}
                      rows={4}
                      fluid
                      placeholder={t.customers.form.add_description}
                      error={validation.description.error && validation.description.skipped}
                      onBlur={makeOnBlur("description")}
                    />
                    {validation.description.error && validation.description.skipped ? (
                        <div className="label-error">{validation.description.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
                </Form>

                <Form.Field>
                  <label className="label-item mt-7">
                    {t.customers.form.location}
                    <Asterisk color="#172B4D" />{" "}
                    <span
                      className="position-relative c-pointer"
                      onMouseOver={() => setTeamsTooltip(true)}
                      onMouseLeave={() => setTeamsTooltip(false)}
                    >
                      {showTeamsTooltip ? (
                        <>
                          <InfoIconBlue />
                          <ToolTip
                            color="#fff"
                            backgroundColor="#172B4D"
                            position={
                              selectedLanguage == "ar"
                                ? "left top"
                                : "right top"
                            }
                            show={showTeamsTooltip}
                            textBoxWidth="100px"
                            arrowAlign="center"
                            fontSize="9px"
                            fontWeight="400"
                            fontFamily={
                              selectedLanguage == "ar"
                                ? "Noto Kufi Arabic"
                                : "Roboto"
                            }
                            padding="4px 14px 4px 7px"
                            lineHeight="16px"
                            borderRadius="6px"
                            static
                            moveDown="0px"
                          >
                            <span className="work-order-preview-tooltip parts">
                              {t.customers.form.served}
                            </span>
                          </ToolTip>
                        </>
                      ) : (
                        <InfoIcon />
                      )}
                    </span>
                    {/* <Icon name="asterisk" color="red" size="small" /> */}
                  </label>
                  <div className="flexbox align-items-start">
                    <Dropdown
                      placeholder={t.customers.form.add_location}
                      noResultsMessage={t.common.no_results_found}
                      disabled={locationLoading}
                      fluid
                      selection
                      className="people-dropdown mb-0"
                      multiple
                      options={options.locations.options}
                      value={data.location}
                      search={(options, query) => {
                        const filteredOptions = [];
                        const addedKeys = new Set(); // To track and avoid duplicate entries

                        options.forEach((option) => {
                          const isParent = !option.parentId;
                          const matches = option.text
                            .toLowerCase()
                            .includes(query.toLowerCase());

                          // If the parent matches, add it and all related sub-locations
                          if (isParent && matches) {
                            if (!addedKeys.has(option.key)) {
                              filteredOptions.push(option);
                              addedKeys.add(option.key);
                            }
                            options.forEach((subOption) => {
                              if (
                                subOption.parentId === option.key &&
                                !addedKeys.has(subOption.key)
                              ) {
                                filteredOptions.push(subOption);
                                addedKeys.add(subOption.key);
                              }
                            });
                          }
                          // If a sub-location matches, add both the sub-location and its parent
                          else if (!isParent && matches) {
                            const parentOption = options.find(
                              (opt) => opt.key === option.parentId
                            );
                            if (
                              parentOption &&
                              !addedKeys.has(parentOption.key)
                            ) {
                              filteredOptions.push(parentOption);
                              addedKeys.add(parentOption.key);
                            }
                            if (!addedKeys.has(option.key)) {
                              filteredOptions.push(option);
                              addedKeys.add(option.key);
                            }
                          }
                        });

                        return filteredOptions;
                      }}
                      onChange={onValuesChange("location")}
                      error={
                        validation.location.error && validation.location.skipped
                      }
                      onBlur={makeOnBlur("location")}
                    />
                    {userPermissions?.location?.create &&
                    userPermissions?.location?.view ? (
                      <div
                        className="add-location ml-2 mr-2 p-1 d-flex align-items-center justify-content-center c-pointer"
                        onClick={() => {
                          setToggleAsideModal(true);
                          setToggleEditModal(false);
                        }}
                        // style={{ backgroundColor: "#E9F2FF", height: "37px" }}
                      >
                        <AddIcon />
                      </div>
                    ) : null}
                  </div>
                  {validation.location.error && validation.location.skipped ? (
                    <div className="label-error">
                      {validation.location.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.form.phone}
                    <Asterisk color="#172B4D" />
                  </label>
                  <PhoneInput
                    defaultCountry="jo"
                    value={data.phone}
                    placeholder={t.customers.form.add_number}
                    onChange={(value) => {
                      if (!phone) {
                        setPhone(true);
                        return;
                      }
                      setData({
                        ...data,
                        phone: value || "",
                      });
                      if (data.isSame) {
                        setData({
                          ...data,
                          phone: value || "",
                          contact_phone: value || "",
                        });
                      }
                      if (!value) {
                        setValidation({
                          ...validation,
                          phone: {
                            ...validation.phone,
                            error: false,
                            skipped: false,
                            message: t.common.required_field,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      } else if (value && isPhoneValid(value)) {
                        setValidation({
                          ...validation,
                          phone: {
                            ...validation.phone,
                            error: false,
                            skipped: true,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      } else if (value && !isPhoneValid(value)) {
                        setValidation({
                          ...validation,
                          phone: {
                            ...validation.phone,
                            error: true,
                            skipped: true,
                            message: t.customers.form.invalid_phone,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      }
                    }}
                    error={
                      validation?.phone?.error && validation?.phone?.skipped
                    }
                  />
                  {validation?.phone?.error && validation?.phone?.skipped ? (
                    <div className="label-error">
                      {validation?.phone?.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.form.email}
                    <Asterisk color="#172B4D" />
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_email}
                    value={data.email}
                    onChange={onValuesChange("email")}
                    error={validation.email.error && validation.email.skipped}
                    onBlur={makeOnBlur("email")}
                  />
                  {validation.email.error && validation.email.skipped ? (
                    <div className="label-error">
                      {validation.email.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>
                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.form.website}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_website}
                    value={data.website}
                    onChange={onValuesChange("website")}
                    onBlur={makeOnBlur("website")}
                    error={validation.website?.error && validation.website?.skipped}
                  />
                  {validation.website.error && validation.website.skipped ? (
                      <div className="label-error">
                        {validation.website.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.form.service_type}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_service_type}
                    value={data.serviceType}
                    onChange={onValuesChange("serviceType")}
                    onBlur={makeOnBlur("serviceType")}
                    error={validation.serviceType?.error && validation.serviceType?.skipped}
                  />
                  {validation.serviceType.error && validation.serviceType.skipped ? (
                      <div className="label-error">
                        {validation.serviceType.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field
                  className="industry-type"
                  // style={{ minHeight: "71px" }}
                >
                  <label className="label-item mt-1">{t.common.industry}<Asterisk color="#172B4D" /></label>
                  <Dropdown
                    placeholder={t.customers.form.add_industry}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    clearable
                    selection
                    search
                    options={options.Industry}
                    value={data.Industry}
                    onChange={onValuesChange("Industry")}
                    onBlur={makeOnBlur("industry", (cd) => cd.Industry)}
                    error={validation.industry.error && validation.industry.skipped}
                  />
                  {validation.industry.error && validation.industry.skipped ? (
                      <div className="label-error">
                        {validation.industry.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Divider />

                <div className="billing-info mt-7  d-flex">
                  <ContactInfoIcon />
                  <p
                    className={`font16 mt-1 required-text ${
                      selectedLanguage == "en" ? "ml-2" : "mr-2"
                    }`}
                  >
                    {t.customers.form.contact_information}
                  </p>
                </div>

                <Form.Field>
                  <label className="label-item mt-8">
                    {t.customers.contact_name}
                  </label>
                  <Input
                    disabled={data.isSame}
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_contact_name}
                    value={data.contact_name}
                    onChange={onValuesChange("contact_name")}
                    onBlur={makeOnBlur("contact_name")}
                    error={validation.contact_name.error && validation.contact_name.skipped}
                  />
                  {validation.contact_name.error && validation.contact_name.skipped ? (
                      <div className="label-error">
                        {validation.contact_name.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.contact_phone}
                  </label>
                  <PhoneInput
                    disabled={data.isSame}
                    disableDialCodePrefill={!data.isSame ? true : false}
                    defaultCountry="jo"
                    // forceDialCode={true}
                    value={data.contact_phone}
                    placeholder={t.customers.form.add_number}
                    onChange={(value) => {
                      // console.log('values', value);
                      if (!phone) {
                        setPhone(true);
                        return;
                      }
                      setData({
                        ...data,
                        contact_phone: value || "",
                      });
                      if (!value) {
                        setValidation({
                          ...validation,
                          contact_phone: {
                            ...validation.contact_phone,
                            error: false,
                            skipped: false,
                            message: t.common.required_field,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      } else if (value && isPhoneValid(value)) {
                        setValidation({
                          ...validation,
                          contact_phone: {
                            ...validation.contact_phone,
                            error: false,
                            skipped: true,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      } else if (value && !isPhoneValid(value)) {
                        setValidation({
                          ...validation,
                          contact_phone: {
                            ...validation.contact_phone,
                            error: true,
                            skipped: true,
                            message: t.customers.form.invalid_phone,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      }
                    }}
                    error={
                      validation?.contact_phone?.error &&
                      validation?.contact_phone?.skipped
                    }
                  />
                  {validation?.contact_phone?.error &&
                  validation?.contact_phone?.skipped ? (
                    <div className="label-error">
                      {validation?.contact_phone?.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <Form.Field
                  className="industry-type"
                  // style={{ minHeight: "71px" }}
                >
                  <label className="label-item mt-1">
                    {t.customers.contact_email}
                  </label>
                  <Input
                    disabled={data.isSame}
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_contact_email}
                    value={data.contact_email}
                    onChange={onValuesChange("contact_email")}
                    className="email-password-ltr"
                    error={
                      validation.contact_email.error &&
                      !data.isSame &&
                      validation.contact_email.skipped
                    }
                    onBlur={(e) => {
                      if (
                        validation.contact_email.pattern(data.contact_email)
                      ) {
                        setValidation({
                          ...validation,
                          contact_email: {
                            ...validation.contact_email,
                            error: false,
                            skipped: true,
                          },
                        });
                      } else {
                        if (!data.isSame && data.contact_email !== "") {
                          setValidation({
                            ...validation,
                            contact_email: {
                              ...validation.contact_email,
                              error: true,
                              skipped: true,
                            },
                          });
                        } else {
                          setValidation({
                            ...validation,
                            contact_email: {
                              ...validation.contact_email,
                              error: false,
                              skipped: false,
                            },
                          });
                        }
                      }
                    }}
                  />
                  {validation.contact_email.error &&
                  !data.isSame &&
                  validation.contact_email.skipped ? (
                    <div className="label-error">
                      {validation.contact_email.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <div className="mt-4 mb-4">
                  <Checkbox
                    checked={data.isSame}
                    label={t.customers.same_info}
                    onChange={(e, value) => {
                      if (value.checked) {
                        setData({
                          ...data,
                          isSame: true,
                          contact_email: data.email,
                          contact_phone: data.phone,
                          contact_name: data.name,
                        });
                      } else {
                        setData({
                          ...data,
                          isSame: false,
                          contact_email: "",
                          contact_phone: "",
                          contact_name: "",
                        });
                      }
                    }}
                  />
                </div>
              </div>

              <div className={activePane === 1 ? "d-block" : "d-none"}>
                <div className="billing-info mt-7">
                  <BillingInfoIcon />
                  <span
                    className={`font16 required-text ${
                      selectedLanguage == "en" ? "ml-2" : "mr-2"
                    }`}
                  >
                    {t.customers.form.billing_information}
                  </span>
                </div>
                <Form.Field>
                  <label className="label-item mt-7">
                    {t.customers.form.name}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_name}
                    value={data.billing_name}
                    onChange={onValuesChange("billing_name")}
                    onBlur={makeOnBlur("billing_name")}
                    error={
                        validation?.billing_name?.error &&
                        validation?.billing_name?.skipped
                    }
                  />
                  {validation?.billing_name?.error &&
                  validation?.billing_name?.skipped ? (
                      <div className="label-error">
                        {validation?.billing_name?.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field autoComplete="off">
                  <label className="label-item">
                    {t.customers.form.country}
                  </label>
                  <Dropdown
                    placeholder={t.locations.form.country_add}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    search
                    clearable
                    selection
                    options={options.countries}
                    value={data.country}
                    onChange={onValuesChange("country")}
                  />
                </Form.Field>

                <Form.Field autoComplete="off">
                  <label className="label-item">{t.customers.form.city}</label>
                  <Dropdown
                    placeholder={t.locations.form.city_add}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    search
                    clearable
                    selection
                    options={options.cities}
                    value={data.city}
                    onChange={onValuesChange("city")}
                  />
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.postal_code}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_postal}
                    value={data.billing_postal_code}
                    onChange={onValuesChange("billing_postal_code")}
                    error={validation.billing_postal_code.error && validation.billing_postal_code.skipped}
                    onBlur={makeOnBlur("billing_postal_code")}
                  />
                  {validation.billing_postal_code.error && validation.billing_postal_code.skipped ? (
                      <div className="label-error">{validation.billing_postal_code.message}</div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.address}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_address}
                    value={data.billing_address}
                    onChange={onValuesChange("billing_address")}
                    error={validation.billing_address.error && validation.billing_address.skipped}
                    onBlur={makeOnBlur("billing_postal_code")}
                  />
                  {validation.billing_address.error && validation.billing_address.skipped ? (
                      <div className="label-error">{validation.billing_address.message}</div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.address_line_2}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_address}
                    value={data.billing_addressLine2}
                    onChange={onValuesChange("billing_addressLine2")}
                    error={validation.billing_addressLine2.error && validation.billing_addressLine2.skipped}
                    onBlur={makeOnBlur("billing_postal_code")}
                  />
                  {validation.billing_addressLine2.error && validation.billing_addressLine2.skipped ? (
                      <div className="label-error">{validation.billing_addressLine2.message}</div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.address_line_3}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_address}
                    value={data.billing_addressLine3}
                    onChange={onValuesChange("billing_addressLine3")}
                    error={validation.billing_addressLine3.error && validation.billing_addressLine3.skipped}
                    onBlur={makeOnBlur("billing_postal_code")}
                  />
                  {validation.billing_addressLine3.error && validation.billing_addressLine3.skipped ? (
                      <div className="label-error">{validation.billing_addressLine3.message}</div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">{t.customers.form.rate}</label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    type="number"
                    onKeyDown={(evt) => handleKeyDown(evt)}
                    min="0"
                    placeholder={t.customers.form.add_rate}
                    value={data.billing_rate}
                    onChange={onValuesChange("billing_rate")}
                    error={validation.billing_rate.error && validation.billing_rate.skipped}
                    onBlur={makeOnBlur("billing_postal_code")}
                  />
                  {validation.billing_rate.error && validation.billing_rate.skipped ? (
                      <div className="label-error">{validation.billing_rate.message}</div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.currency}
                  </label>
                  <Dropdown
                    placeholder={t.customers.form.add_currency}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    search
                    selection
                    clearable
                    options={currencies}
                    value={data.billing_currency}
                    onChange={onValuesChange("billing_currency")}
                  />
                </Form.Field>
              </div>
            </div>

            <div className={`form-button-container mt-0`}>
              <button
                content={t.common.cancel}
                className="form-action-button"
                basic
                type="button"
                onClick={() =>
                  initChange ? setNewCancelModal(true) : cancelHandler()
                }
              >
                {t.assets.form.cancel}
              </button>
              {activePane == 1 ? (
                <button
                  content={t.common.submit_btn}
                  primary
                  type="button"
                  onClick={updateCustomerHandler}
                  className="form-action-button blue"
                >
                  {t.common.edit}
                </button>
              ) : (
                <button
                  content={t.common.next}
                  className="form-action-button blue"
                  type="button"
                  primary
                  onClick={() => {
                    changeTab(activePane + 1);
                  }}
                >
                  {t.common.next}
                </button>
              )}
            </div>
          </div>
        </Resizable>
      </div>
      <div
        className={
          toggled ? "aside-modal-background active" : "aside-modal-background"
        }
        onClick={() => (initChange ? setNewCancelModal(true) : cancelHandler())}
      ></div>

      {/* success modal */}
      <Modal
        size="tiny"
        open={successModal}
        onClose={() => {
          toggleSuccessModal(false);
        }}
      >
        <Modal.Content>
          <div className="text-center">
            <div className="checkmark-wrapper">
              <Icon name="checkmark" color="white" size="huge" />
            </div>
            <p className="status-modal-popup-message">
              {t.customers.form.customer_updated_success}
            </p>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            onClick={() => {
              toggleSuccessModal(false);

              history.push("/customers");
            }}
          >
            {t.common.ok}
          </Button>
        </Modal.Actions>
      </Modal>

      <NewCancelModal
        yesCallback={() => {
          cancelHandler();
        }}
        title={t.parts.form.changes}
      >
        <p className="cancel-child"> {t.common.cancel_2statement}</p>
      </NewCancelModal>
      {toggleAsideModal && (
        <AddLocation
          toggled={toggleAsideModal}
          allIds={allIds}
          role={role}
          currentUserId={currentUserId}
          untoggle={() => {
            setToggleAsideModal(false);
            setToggleEditModal(true);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
          }}
          setRefresh={setRefresh}
          refresh={refresh}
          parentLocation={null}
          fromCustomer={true}
          handleSuccess={async (res) => {
            if (!(role === "super_admin")) {
              let allLocation = [...data?.location];
              allLocation.push(res?.data?.id);
              setData({
                ...data,
                location: allLocation,
                selectedLocation: allLocation,
              });

              let updatedAllIds = [...allIds];
              const [userData] = await Promise.all([getUserData(user.id)]);

              dispatch(props.fulfillUser(userData));
              userData?.locations?.length &&
                userData.locations.forEach((location) => {
                  if (!updatedAllIds.some((inv) => inv == location?.id)) {
                    updatedAllIds.push(location?.id);
                  }

                  location.subLocations.forEach((subLocation) => {
                    if (!updatedAllIds.some((inv) => inv == subLocation?.id)) {
                      updatedAllIds.push(subLocation?.id);
                    }
                  });
                });

              setAllIds(updatedAllIds);
              await fetchLocationsOptions(updatedAllIds);
            } else {
              setToggleAsideModal(false);
              setToggleEditModal(true);
              let allLocation = [...data?.location];

              allLocation.push(res?.data?.id);

              setData({
                ...data,
                location: allLocation,
                selectedLocation: allLocation,
              });
            }
          }}
        />
      )}
    </>
  );
}

export default connect(null, auth.actions)(Edit);
